export default __webpack_public_path__ + "static/media/DAIF_Data_Screen2_In-end.ac8b445c.jpg";